/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMathOff = createReactComponent("math-off", "IconMathOff", [
  ["path", { d: "M14 19l2.5 -2.5", key: "svg-0" }],
  ["path", { d: "M18.5 14.5l1.5 -1.5", key: "svg-1" }],
  ["path", { d: "M3 3l18 18", key: "svg-2" }],
  ["path", { d: "M19 5h-7l-.646 2.262", key: "svg-3" }],
  ["path", { d: "M10.448 10.431l-2.448 8.569l-3 -6h-2", key: "svg-4" }]
]);

export { IconMathOff as default };
//# sourceMappingURL=IconMathOff.js.map
